import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  BLOG_CATEGORIES,
  BLOG_POSTS,
  formatPostDate,
} from '../../data/blogPosts';
import { BlogIndexSeo } from '../Seo/BlogSeo';
import './Blog.css';

function PostCard({ post }) {
  return (
    <Link to={`/blog/${post.slug}`} className="blog-card">
      <div className="blog-card-media">
        <img src={post.cover} alt={post.coverAlt || ''} loading="lazy" />
        {post.interactive ? (
          <span className="blog-card-badge">Interactive</span>
        ) : null}
      </div>
      <div className="blog-card-body">
        <div className="blog-card-meta">
          <span className="blog-card-cat">{post.category}</span>
          <span aria-hidden="true">·</span>
          <time dateTime={post.date}>{formatPostDate(post.date)}</time>
        </div>
        <h2 className="blog-card-title">{post.title}</h2>
        <p className="blog-card-lede">{post.lede}</p>
        <span className="blog-card-cta">
          {post.interactive ? 'Explore →' : 'Read →'}
        </span>
      </div>
    </Link>
  );
}

export default function Blog() {
  const [category, setCategory] = useState('all');

  const sorted = [...BLOG_POSTS].sort((a, b) => b.date.localeCompare(a.date));
  const posts =
    category === 'all'
      ? sorted
      : sorted.filter((post) => post.category === category);

  return (
    <div className="blog-page font-bai">
      <BlogIndexSeo posts={sorted} />

      <section className="blog-hero">
        <div className="max-w-5xl mx-auto px-6 md:px-12 py-16 md:py-24">
          <p className="blog-kicker mb-4">Field notes</p>
          <h1 className="blog-title mb-5">
            Writing from the <em>system</em>
          </h1>
          <p className="blog-lede">
            Product, field, and market notes on digital design, precision framing,
            and backyard building with local partners across Central Texas.
          </p>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 md:px-12 py-12 md:py-16 pb-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-8 md:mb-10">
          <div>
            <p className="text-sm font-medium uppercase tracking-widest text-construx-red mb-2">
              {posts.length} {posts.length === 1 ? 'post' : 'posts'}
            </p>
            <h2 className="text-2xl md:text-3xl font-bold text-warm-900">
              Latest from Construx
            </h2>
          </div>
          <div className="blog-filters" role="tablist" aria-label="Filter by category">
            {BLOG_CATEGORIES.map((cat) => (
              <button
                key={cat.id}
                type="button"
                role="tab"
                aria-selected={category === cat.id}
                className={`blog-filter${category === cat.id ? ' is-active' : ''}`}
                onClick={() => setCategory(cat.id)}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>

        {posts.length ? (
          <div className="blog-grid">
            {posts.map((post) => (
              <PostCard key={post.slug} post={post} />
            ))}
          </div>
        ) : (
          <p className="blog-empty">No posts in this category yet.</p>
        )}
      </section>

      <section className="blog-cta-band">
        <h2>Ready to start a backyard project?</h2>
        <p>
          Talk with Construx or find a local build partner already delivering the
          system in Central Texas.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link to="/interest" className="blog-btn">
            Get in touch
          </Link>
          <Link
            to="/partners"
            className="blog-btn"
            style={{ background: 'transparent', color: '#be4128', border: '1.5px solid #be4128' }}
          >
            Find a partner
          </Link>
        </div>
      </section>
    </div>
  );
}
